module.exports = __webpack_public_path__ + "img/compact.1da014f2.png";